import { defineComponent as o, withDirectives as r, openBlock as s, createElementBlock as c, renderSlot as i, unref as n } from "vue";
import a from "../../node_modules/v-wave/dist/es/index.mjs";
const m = { class: "ist-item" }, d = /* @__PURE__ */ o({
  __name: "IstItem",
  setup(l) {
    const { vWave: e } = a.createLocalWaveDirective();
    return (t, _) => r((s(), c("div", m, [
      i(t.$slots, "default", {}, void 0, !0)
    ])), [
      [n(e)]
    ]);
  }
});
export {
  d as default
};
